// LIBRARY IMPORTS
import { FC, useEffect, useState } from "react";
import { Typography, useTheme, makeStyles, Card, CardContent } from "@material-ui/core";
// LOCAL IMPORTS
import { IDiaCortesiaDetalle } from "gateways/notificaciones.interfaces";
import Term from "components/term";
// STYLES IMPORTS
import styles from './styles';
import MonthCalendar from "./month-calendar";
import { dateFormatToUTC } from "utils/dates";

const useStyles = makeStyles(styles);

export interface IProps {
    initialDiasCortesia: IDiaCortesiaDetalle[]; // días de cortesia 
    selectedDays: string[];
    setSelectedDays: (days: string[]) => void
    legend: {
        titleSeleccionado: string;
        titleHabilitados: string;
        titleDeshabilitado: string
    },
    noDiasCortesiaText: string;
    limiteDiasSeleccionables?:number;
    fechaPorDefecto?: string
    isDisabledOnClick?:boolean;
}

const Calendar: FC<IProps> = (props) => {
    const { initialDiasCortesia, selectedDays, setSelectedDays, legend, noDiasCortesiaText,fechaPorDefecto,isDisabledOnClick, limiteDiasSeleccionables= 1} = props;
    // HOOKS
    const theme = useTheme();
    const classes = useStyles(theme);
 
    // STATES
    const [availableYearMonth, setAvailableYearMonth] = useState<{ year: number, months: number[] }[]>([])
    const [diasCortesia, setDiasCortesia]= useState<IDiaCortesiaDetalle[]>([])
    
    const updateSelectedDays = (newDate: string) => {
        // console.log('updateSelectedDays newDate', newDate)
        const fecha = dateFormatToUTC(newDate,'YYYY-MM-DD')
        const currActive = diasCortesia.filter(d => d.seleccionada && d.modificable);
        const currSeleccionados = currActive.length
        let newSelected = [...selectedDays]
        let requiredAdd = true
        if(limiteDiasSeleccionables === currSeleccionados || newSelected.includes(fecha)){   
            if(newSelected.includes(fecha)) {
                // El usuario ha seleccionado una fecha previamente seleccionada => se quita como seleccionada
                newSelected = newSelected.filter( item => item !== fecha)
                requiredAdd = false
            } else {
                // Eliminamos el primer elemento insertado - ya que sino excedemos limite de dias seleccionables
                newSelected.shift()
            }
        } 
        if(requiredAdd){
            // Añadimos el nuevo elemento
            newSelected.push(fecha) 
        }

        setSelectedDays(newSelected)
    }



    useEffect(() => {
        //console.log('effect initialDiasCortesia',initialDiasCortesia.length, selectedDays)
        // Extrae el conjunto de meses y años que vamos a renderizar como calendarios
        if(initialDiasCortesia.length>0){
            let availableYearMonth: { year: number, months: number[] }[] = [];
            for (let dia of initialDiasCortesia) {
                let availableYear = availableYearMonth.find(({ year }) => year === new Date(dia.fecha).getFullYear());
                if (!availableYear) availableYearMonth.push({ year: new Date(dia.fecha).getFullYear(), months: [new Date(dia.fecha).getMonth()] });
                else if (!availableYear.months.includes(new Date(dia.fecha).getMonth())) availableYear.months.push(new Date(dia.fecha).getMonth());
            }
            setAvailableYearMonth(availableYearMonth)
            setDiasCortesia(initialDiasCortesia)
        }
    }, [])

    useEffect(() => {
        //console.log('effect selectedDays', selectedDays, diasCortesia.length)
        if(diasCortesia.length>0){
            const newCortesia = diasCortesia.map( d =>{
                return ( 
                    selectedDays.includes(d.fecha)
                        ? {...d, seleccionada: true/*, indexSelected: selectedDays.findIndex( item => item === d.fecha )*/} 
                        : {...d, seleccionada: false/*, indexSelected: undefined*/}
                    )
                }
            )
            setDiasCortesia(newCortesia)
        }
        
    }, [selectedDays])

    


    return (
        <div >
            {/* <Card className={classes.paddingFechaCargo}>
                <CardContent className={classes.fechaCargo}> */}
                <div className={classes.fechaCargo}>
                    <Typography className={[classes.titleText, classes.marginB15].join(' ')}>
                        <Term component='Domiciliaciones' text='Seleccionar fecha concreta cargo en cuenta' />
                    </Typography>
                      
                    {/* Leyenda */}
                    {(diasCortesia && diasCortesia.length > 0) &&
                        <>
                            <div className={classes.containerLeyendaDiasVoluntaria}>
                                {/* Día seleccionado */}
                                <div className={classes.containerExplicacionLeyenda}>
                                    <span className={[classes.leyendaDiasVoluntaria, classes.colorDiaSeleccionado].join(' ')} />
                                    <div className={classes.fechaPrevista}>
                                        <Typography>{legend.titleSeleccionado}</Typography>
                                        {selectedDays.length === 0 &&   
                                            <p style={{ fontWeight: 'bold', margin: 0 }}><Term component='Global' text='Sin especificar' /></p>
                                        }

                                    </div>
                                </div>
                                {/* Días habilitados */}
                                <div className={classes.containerExplicacionLeyenda}>
                                    <span className={[classes.leyendaDiasVoluntaria, classes.colorDiasHabilitados].join(' ')} />
                                    <Typography>{legend.titleHabilitados}</Typography>
                                    {/* <Term component='Domiciliaciones' text='Leyenda días habilitados domiciliación voluntaria' /> */}
                                </div>
                                {/* Días deshabilitados */}
                                <div className={classes.containerExplicacionLeyenda}>
                                    <span className={[classes.leyendaDiasVoluntaria, classes.colorDiasDeshabilitados].join(' ')} />
                                    <Typography>{legend.titleDeshabilitado}</Typography>
                                    {/* <Term component='Domiciliaciones' text='Leyenda días deshabilitados domiciliación voluntaria' /> */}
                                </div>
                            </div>
                        </>
                    }
                </div>
                {/* </CardContent> */}
                {!diasCortesia || diasCortesia.length < 1
                    ?
                        <div className={classes.paddingFechaCargo}>
                            {/* <Term component='Domiciliaciones' text='Días voluntaria no disponibles' /> */}
                            {noDiasCortesiaText}
                        </div>
                    :
                        <div className={[classes.calendarFechCargo, classes.rootCard].join(' ')} >
                            {
                                availableYearMonth.map(yearMonth => {
                                    return yearMonth.months.map(m => {
                                        const firstDate = new Date(yearMonth.year, m, (new Date().getDay() + 2));
                                        return (
                                            <Typography component="div" key={m} className={classes.calendar}>
                                                <MonthCalendar
                                                    key={m}
                                                    firstDate={firstDate}
                                                    diasCortesia={diasCortesia}
                                                    maxDiasSeleccionables={limiteDiasSeleccionables}
                                                    fechaPorDefecto={fechaPorDefecto}
                                                    isDisabledOnClick={isDisabledOnClick}
                                                    setDiaSeleccionado={updateSelectedDays}
                                                />
                                            </Typography>
                                        );
                                    });
                                })
                            }
                        </div>

                }
            {/* </Card> */}
        </div>
    );
};

export default Calendar;
